import classnames from 'classnames';
import { startOfWeekLocale } from 'components/DateRangePicker/mondayBasedLocales';
import { isSameDay, isWithinInterval } from 'date-fns';
import addDays from 'date-fns/addDays';
import getDay from 'date-fns/getDay';
import getDaysInMonth from 'date-fns/getDaysInMonth';
import React from 'react';

import DatePickerDay from './DatePickerDay';

const CSS = require('./DatePickerMonth.module.scss');

const TODAY = new Date();
const START_OF_WEEKDAY = startOfWeekLocale(TODAY);

interface DatePickerMonthProps {
  displayedMonth: Date;
  selectedStartDate?: Date;
  selectedEndDate?: Date;
  onDateChange: (newDate: string) => void;
  variant: 'pink' | 'jade';
}

function DatePickerMonth({
  displayedMonth,
  selectedStartDate,
  selectedEndDate,
  onDateChange,
  variant,
}: DatePickerMonthProps) {
  const startDay = getDay(displayedMonth);
  const startOffset =
    startDay === 0 && getDay(START_OF_WEEKDAY) === 1
      ? 6
      : getDay(displayedMonth) - getDay(START_OF_WEEKDAY);
  const nrOfDaysInMonth = getDaysInMonth(displayedMonth);
  const daysInMonth = Array(nrOfDaysInMonth)
    .fill(0)
    .map((elem, index) => addDays(displayedMonth, index));

  const isDaySelected = (day: Date) =>
    selectedStartDate || selectedEndDate
      ? isSameDay(day, selectedStartDate) || isSameDay(day, selectedEndDate)
      : false;
  const isDayWithinInterval = (day: Date) =>
    selectedStartDate
      ? isWithinInterval(day, {
          start: selectedStartDate,
          end: selectedEndDate || selectedStartDate,
        })
      : false;

  return (
    <ol className={CSS.MonthList}>
      {Array(startOffset)
        .fill(0)
        .map((x, index) => (
          <li key={`empty-day-${index}`} className={CSS.ListItem} />
        ))}
      {daysInMonth.map((day, index) => (
        <li
          key={`day-${index}`}
          className={classnames(CSS.ListItem, {
            [CSS.SelectedDay]: isDaySelected(day) || isDayWithinInterval(day),
            [CSS.FirstDay]: isSameDay(day, selectedStartDate),
            [CSS.LastDay]: isSameDay(day, selectedEndDate),
            [CSS.FirstOfMonth]: index === 0,
            [CSS.LastOfMonth]: index === nrOfDaysInMonth - 1,
            [CSS.OnlySelectedDay]: isDaySelected(day) && !selectedEndDate,
          })}
          data-variant={variant}
        >
          <DatePickerDay day={day} onDateChange={onDateChange} />
        </li>
      ))}
    </ol>
  );
}

export default DatePickerMonth;
